<template>
  <div>
    <h5 class="text-center">Для подтверждения операции введите код</h5>
    <h3 class="text-center"><strong>{{ code }}</strong></h3>
    <div>
      <input type="number" v-model="setCode" placeholder="Код" class="form-control">
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      code: Math.floor(1000 + Math.random() * 9999),
      setCode: null,
    }
  },
  methods: {
    validate() {
      return (this.code + '') === (this.setCode + '');
    }
  }
}

</script>
